class LqdTypewriterHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initTypewriter();

  }

  getDefaultSettings() {
    return {
      selectors: {
        typewriterElement: '[data-typewriter]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $typewriterElement: this.$element.find(selectors.typewriterElement),
    }
  }

  initTypewriter() {

    this.elements.$typewriterElement.liquidTypewriter();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdTypewriterHandler, { $element } );
};